export default __webpack_public_path__ + "static/media/auth0.89670a96.svg";